"use strict";

var _slicedToArray = require("/vercel/path1/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/vercel/path1/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/vercel/path1/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/vercel/path1/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path1/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRedoclyRegistryURL = exports.RedoclyClient = void 0;

var fs_1 = require("fs");

var path_1 = require("path");

var os_1 = require("os");

var colorette_1 = require("colorette");

var registry_api_1 = require("./registry-api");

var config_1 = require("../config/config");

var utils_1 = require("../utils");

var TOKEN_FILENAME = '.redocly-config.json';

var RedoclyClient = /*#__PURE__*/function () {
  function RedoclyClient(region) {
    _classCallCheck(this, RedoclyClient);

    this.accessTokens = {};
    this.region = this.loadRegion(region);
    this.loadTokens();
    this.domain = region ? config_1.DOMAINS[region] : process.env.REDOCLY_DOMAIN || config_1.DOMAINS[config_1.DEFAULT_REGION];
    this.registryApi = new registry_api_1.RegistryApi(this.accessTokens, this.region);
  }

  _createClass(RedoclyClient, [{
    key: "loadRegion",
    value: function loadRegion(region) {
      if (region && !config_1.DOMAINS[region]) {
        process.stdout.write(colorette_1.red("Invalid argument: region in config file.\nGiven: ".concat(colorette_1.green(region), ", choices: \"us\", \"eu\".\n")));
        process.exit(1);
      }

      if (process.env.REDOCLY_DOMAIN) {
        return Object.keys(config_1.DOMAINS).find(function (region) {
          return config_1.DOMAINS[region] === process.env.REDOCLY_DOMAIN;
        }) || config_1.DEFAULT_REGION;
      }

      return region || config_1.DEFAULT_REGION;
    }
  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    }
  }, {
    key: "hasTokens",
    value: function hasTokens() {
      return utils_1.isNotEmptyObject(this.accessTokens);
    } // <backward compatibility: old versions of portal>

  }, {
    key: "hasToken",
    value: function hasToken() {
      return !!this.accessTokens[this.region];
    }
  }, {
    key: "getAuthorizationHeader",
    value: function getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = this.accessTokens[this.region]; // print this only if there is token but invalid

                if (!(token && !this.isAuthorizedWithRedoclyByRegion())) {
                  _context.next = 4;
                  break;
                }

                process.stderr.write("".concat(colorette_1.yellow('Warning:'), " invalid Redocly API key. Use \"npx @redocly/openapi-cli login\" to provide your API key\n"));
                return _context.abrupt("return", undefined);

              case 4:
                return _context.abrupt("return", token);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    } // </backward compatibility: portal>

  }, {
    key: "setAccessTokens",
    value: function setAccessTokens(accessTokens) {
      this.accessTokens = accessTokens;
    }
  }, {
    key: "loadTokens",
    value: function loadTokens() {
      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);
      var credentials = this.readCredentialsFile(credentialsPath);

      if (utils_1.isNotEmptyObject(credentials)) {
        this.setAccessTokens(Object.assign(Object.assign({}, credentials), credentials.token && !credentials[this.region] && _defineProperty({}, this.region, credentials.token)));
      }

      if (process.env.REDOCLY_AUTHORIZATION) {
        this.setAccessTokens(Object.assign(Object.assign({}, this.accessTokens), _defineProperty({}, this.region, process.env.REDOCLY_AUTHORIZATION)));
      }
    }
  }, {
    key: "getValidTokens",
    value: function getValidTokens() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all(Object.entries(this.accessTokens).map(function (_ref2) {
                  var _ref3 = _slicedToArray(_ref2, 2),
                      key = _ref3[0],
                      value = _ref3[1];

                  return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.t0 = key;
                            _context2.t1 = value;
                            _context2.next = 4;
                            return this.verifyToken(value, key);

                          case 4:
                            _context2.t2 = _context2.sent;
                            return _context2.abrupt("return", {
                              region: _context2.t0,
                              token: _context2.t1,
                              valid: _context2.t2
                            });

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));
                }));

              case 2:
                return _context3.abrupt("return", _context3.sent.filter(function (item) {
                  return Boolean(item.valid);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getTokens",
    value: function getTokens() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.hasTokens()) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 3;
                return this.getValidTokens();

              case 3:
                _context4.t0 = _context4.sent;
                _context4.next = 7;
                break;

              case 6:
                _context4.t0 = [];

              case 7:
                return _context4.abrupt("return", _context4.t0);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "isAuthorizedWithRedoclyByRegion",
    value: function isAuthorizedWithRedoclyByRegion() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.hasTokens()) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", false);

              case 2:
                accessToken = this.accessTokens[this.region];
                _context5.t0 = !!accessToken;

                if (!_context5.t0) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 7;
                return this.verifyToken(accessToken, this.region);

              case 7:
                _context5.t0 = _context5.sent;

              case 8:
                return _context5.abrupt("return", _context5.t0);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "isAuthorizedWithRedocly",
    value: function isAuthorizedWithRedocly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.t0 = this.hasTokens();

                if (!_context6.t0) {
                  _context6.next = 7;
                  break;
                }

                _context6.t1 = utils_1;
                _context6.next = 5;
                return this.getValidTokens();

              case 5:
                _context6.t2 = _context6.sent;
                _context6.t0 = _context6.t1.isNotEmptyObject.call(_context6.t1, _context6.t2);

              case 7:
                return _context6.abrupt("return", _context6.t0);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "readCredentialsFile",
    value: function readCredentialsFile(credentialsPath) {
      return fs_1.existsSync(credentialsPath) ? JSON.parse(fs_1.readFileSync(credentialsPath, 'utf-8')) : {};
    }
  }, {
    key: "verifyToken",
    value: function verifyToken(accessToken, region) {
      var verbose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (accessToken) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", false);

              case 2:
                return _context7.abrupt("return", this.registryApi.authStatus(accessToken, region, verbose));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "login",
    value: function login(accessToken) {
      var verbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _Object$assign2;

        var credentialsPath, authorized, credentials;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);
                process.stdout.write(colorette_1.gray('\n  Logging in...\n'));
                _context8.next = 4;
                return this.verifyToken(accessToken, this.region, verbose);

              case 4:
                authorized = _context8.sent;

                if (!authorized) {
                  process.stdout.write(colorette_1.red('Authorization failed. Please check if you entered a valid API key.\n'));
                  process.exit(1);
                }

                credentials = Object.assign(Object.assign({}, this.readCredentialsFile(credentialsPath)), (_Object$assign2 = {}, _defineProperty(_Object$assign2, this.region, accessToken), _defineProperty(_Object$assign2, "token", accessToken), _Object$assign2));
                this.accessTokens = credentials;
                this.registryApi.setAccessTokens(credentials);
                fs_1.writeFileSync(credentialsPath, JSON.stringify(credentials, null, 2));
                process.stdout.write(colorette_1.green('  Authorization confirmed. ✅\n\n'));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);

      if (fs_1.existsSync(credentialsPath)) {
        fs_1.unlinkSync(credentialsPath);
      }

      process.stdout.write('Logged out from the Redocly account. ✋\n');
    }
  }]);

  return RedoclyClient;
}();

exports.RedoclyClient = RedoclyClient;

function isRedoclyRegistryURL(link) {
  var domain = process.env.REDOCLY_DOMAIN || config_1.DOMAINS[config_1.DEFAULT_REGION];
  if (!link.startsWith("https://api.".concat(domain, "/registry/"))) return false;
  var registryPath = link.replace("https://api.".concat(domain, "/registry/"), '');
  var pathParts = registryPath.split('/'); // we can be sure, that there is job UUID present
  // (org, definition, version, bundle, branch, job, "openapi.yaml" 🤦‍♂️)
  // so skip this link.
  // FIXME

  if (pathParts.length === 7) return false;
  return true;
}

exports.isRedoclyRegistryURL = isRedoclyRegistryURL;